import { APPLICATIONS_ID } from "@/constants";

type PrivacyItem = {
  icon: string;
  title: string;
  body: string;
};

type Testimonial = {
  name: string;
  body: string;
};

type TrustMetrics = {
  members: string;
  characters: string;
  rating: string;
};

export interface IBrandDefaults {
  subtitle: string;
  perks: string[];
  heroImage?: string;
  trustMetrics: TrustMetrics;
  privacy: PrivacyItem[];
  testimonials: Testimonial[];
}

const PRIVACY_ITEMS: PrivacyItem[] = [
  { icon: "🔒", title: "Discreet billing", body: 'Shows up as "NDAI.CHAT" on your statement. Nothing revealing, ever.' },
  { icon: "🕵️", title: "Private by default", body: "Your chats are yours. We never sell your data or train public models on them." },
  { icon: "🛡️", title: "Encrypted end-to-end", body: "Bank-grade TLS on everything you send. Delete your account in two taps." },
];

export default function getBrandDefaults(applicationId: string): IBrandDefaults {
  const defaultsMap: Record<string, IBrandDefaults> = {
    [APPLICATIONS_ID.SecretMate]: {
      subtitle: "Pick a plan to continue. Cancel anytime.",
      perks: ["Unlimited chats, no surpise", "Long memory — they remember you", "Smart companions with personality"],
      heroImage: "https://cdn.nd-api.com/avatars/1cd4cd07-23a2-4aa4-bd2e-d88df8d0e7bd.webp?width=1600",
      trustMetrics: { members: "80k+", characters: "1k+", rating: "4.8★" },
      privacy: PRIVACY_ITEMS,
      testimonials: [
        { name: "Mansfield A.", body: "After two days I genuinely felt like I was talking to a real person. Worth every cent." },
        { name: "Teresa E.", body: "Best app, hands down. The memory is simply amazing." },
        { name: "Jindal A.", body: "I can finally be myself without filtering every message. No judgment." },
      ],
    },
    [APPLICATIONS_ID.PixelChat]: {
      subtitle: "Pick a plan to continue. Cancel anytime.",
      perks: ["Unlimited messages with AI characters", "Advanced memory & personality", "High-quality image generation"],
      heroImage: "https://cdn.nd-api.com/avatars/9f4f9a5b4283a5bc1224f4844dbc5611.jpg",
      trustMetrics: { members: "800K+", characters: "30K+", rating: "4.7★" },
      privacy: PRIVACY_ITEMS,
      testimonials: [
        { name: "Alex M.", body: "The image quality is incredible. Finally an AI that gets what I'm looking for." },
        { name: "Jordan K.", body: "Worth every penny. The characters feel so real and remember our conversations." },
        { name: "Sam R.", body: "Best investment I've made. The premium features are game-changing." },
      ],
    },
  };

  return (
    defaultsMap[applicationId] || {
      subtitle: "Pick a plan to continue. Cancel anytime.",
      perks: ["Unlimited chats, no waiting lines", "Long memory — they remember you", "Longer replies & conversation images"],
      heroImage: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=1600&h=900&fit=crop&q=80",
      trustMetrics: { members: "1M+", characters: "40K+", rating: "4.8★" },
      privacy: PRIVACY_ITEMS,
      testimonials: [
        { name: "User A.", body: "Amazing experience. The AI feels incredibly real and responsive." },
        { name: "User B.", body: "Best subscription I have. The features are worth every cent." },
        { name: "User C.", body: "Finally an AI chat app that actually delivers on its promises." },
      ],
    }
  );
}
